import { Helmet } from "react-helmet-async";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About - Boobalyz</title>
        <meta
          name="description"
          content="Learn about the Boobalyz breast cancer risk prediction system"
        />
      </Helmet>

      <div className="bg-slate-50 min-h-screen py-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">
            About Boobalyz
          </h1>
          <p className="text-slate-500 text-lg leading-relaxed mb-8">
            Learn about our advanced breast cancer risk prediction system and
            the science behind it.
          </p>

          <div className="bg-white rounded-xl border border-slate-200 p-6 mb-6">
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Our Mission
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Boobalyz is a comprehensive breast cancer risk prediction system
              based on the internationally validated PREDICT algorithm. Our
              mission is to provide healthcare professionals with evidence-based
              tools to support clinical decision-making and improve patient
              outcomes.
            </p>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-6 mb-6">
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Clinical Foundation
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Built on the PREDICT breast cancer prognostic model (version 3.0),
              our system incorporates the latest clinical research and outcomes
              data to provide accurate survival probability estimates and
              treatment benefit assessments.
            </p>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-6">
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Key Features
            </h2>
            <ul className="space-y-2 text-slate-600">
              <li className="flex items-start">
                <span className="text-blue-600 mr-3">•</span>
                <span>Evidence-based risk prediction algorithms</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3">•</span>
                <span>Comprehensive treatment benefit analysis</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3">•</span>
                <span>HIPAA-compliant data handling</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3">•</span>
                <span>Real-time analytics and reporting</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3">•</span>
                <span>Integration with clinical workflows</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
